import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, HashRouter } from "react-router-dom";
import AppModal from "../../components/AppModal/AppModal";
import { ENV } from "../../constants/env";
import AppRoutes from "./app-routes";
import Page from "./components/page";

const Router = ENV.NAVIGATION.HAS_BROWSER_ROUTER ? BrowserRouter : HashRouter;
const routerProps = ENV.NAVIGATION.HAS_BROWSER_ROUTER ? { basename: ENV.PUBLIC_URL } : {};

function App({ store }) {
    return (
        <div className="app">
            <Provider store={store}>
                <Router {...routerProps}>
                    <Page>
                        <AppRoutes />
                        <AppModal />
                    </Page>
                </Router>
            </Provider>
        </div>
    );
}

export default App;
